@use "@/styles/variables" as *;

.container {
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 2px;
	min-width: 0;
}

.recalculateButton {
	white-space: nowrap;
}

// ── Hero card ──────────────────────────────────────────────────────────────────
.heroCard {
	position: relative;
	border: 1px solid $gray-200;
	border-radius: 12px;
	padding: 14px 16px;
	background: linear-gradient(145deg, #ffffff 0%, #fcfdf8 65%, #f8fbf0 100%);
	overflow: hidden;

	&::after {
		content: "";
		position: absolute;
		right: -30px;
		top: -35px;
		width: 120px;
		height: 120px;
		border-radius: 999px;
		background: radial-gradient(circle, rgba(127, 176, 47, 0.22) 0%, rgba(127, 176, 47, 0.02) 65%, transparent 100%);
		pointer-events: none;
	}
}

.heroBadge {
	display: inline-flex;
	align-items: center;
	font-size: 0.6875rem;
	font-weight: 700;
	color: $primary-color;
	background: rgba(127, 176, 47, 0.12);
	border: 1px solid rgba(127, 176, 47, 0.25);
	border-radius: 999px;
	padding: 4px 8px;
	margin-bottom: 8px;
	text-transform: uppercase;
	letter-spacing: 0.05em;
}

.heroTitle {
	margin: 0;
	font-size: 1.05rem;
	font-weight: 700;
	color: $gray-700;
	line-height: 1.3;
	text-transform: uppercase;
}

.heroMetaGrid {
	margin-top: 12px;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
	gap: 10px;
}

.heroMetaItem {
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 10px 14px;
	border: 1px solid rgba(127, 176, 47, 0.3);
	border-radius: 10px;
	background: rgba(127, 176, 47, 0.07);
}

.heroMetaLabel {
	font-size: 0.6875rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: $gray-500;
}

.heroMetaValue {
	font-size: 1.1rem;
	font-weight: 700;
	line-height: 1.3;
	color: $primary-color;
	word-break: break-word;
}

// ── Season toolbar (slot para SimpleTableCard) ─────────────────────────────────
.seasonToolbar {
	display: flex;
	align-items: center;
	gap: 10px;
	justify-content: space-between;
	> div {
		width: 40%;
	}
}

.toolbarLabel {
	font-size: 0.75rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: $gray-600;
	white-space: nowrap;
}

// ── Row states ─────────────────────────────────────────────────────────────────
.emptySeason {
	background-color: $primary-bg;

	td {
		font-style: italic;
		color: $gray-500;
	}
}
